import { formacion, images } from "@/data/content";
import PageHeader from "@/components/site/PageHeader";
import { Reveal } from "@/components/site/Reveal";
import BookCTA from "@/components/site/BookCTA";

export default function Formacion() {
  return (
    <div data-testid="formacion-page">
      <PageHeader
        overline="Formación"
        titleLines={["Un compromiso", "con el aprendizaje", "permanente"]}
      />

      <section className="max-w-[1400px] mx-auto px-5 md:px-10 pb-16 md:pb-24">
        <div className="border-t border-black/10">
          {formacion.items.map((item, i) => (
            <Reveal
              key={item.title}
              delay={i * 0.08}
              className="grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-8 items-baseline py-8 md:py-12 border-b border-black/10 group"
            >
              <span className="md:col-span-1 font-display text-2xl text-[#9C5A4B]/50">
                {String(i + 1).padStart(2, "0")}
              </span>
              <h2 className="md:col-span-7 font-display text-2xl md:text-4xl tracking-tight group-hover:text-[#9C5A4B] transition-colors duration-300">
                {item.title}
              </h2>
              <p className="md:col-span-4 text-[#5c5c5c] md:text-right">
                {item.place}
              </p>
            </Reveal>
          ))}
        </div>

        <Reveal>
          <p className="mt-14 md:mt-20 font-display italic text-2xl md:text-3xl leading-tight max-w-3xl">
            {formacion.note}
          </p>
        </Reveal>
      </section>

      <section className="max-w-[1400px] mx-auto px-5 md:px-10 pb-24 md:pb-32">
        <Reveal>
          <p className="overline mb-6">La consulta</p>
          <div className="overflow-hidden aspect-[16/9] md:aspect-[21/9]">
            <img
              src={images.room}
              alt="Espacio de la consulta"
              className="w-full h-full object-cover"
              data-testid="formacion-room-image"
            />
          </div>
        </Reveal>
      </section>

      <BookCTA />
    </div>
  );
}
